import React from 'react';
import randomFighter from '../../../../assets/random_fighter.svg';
import ChallengerModal from './ChallengerModal';

const MatchmakingModalNew = ({ isOpen, onClose }) => {
  return (
    <ChallengerModal
      isOpen={isOpen}
      onClose={onClose}
      icon={<img src={randomFighter} alt='fighter_icon' style={{ borderRadius: '6px', border: '1px solid black' }} />}
      heading='Post to Public'
      boldText='Random Fighter!'
      subText='Wait for a notification on your challenge request!'
    />
  );
};

export default MatchmakingModalNew;
